import clsx from 'clsx';
import { ChangeEventHandler, forwardRef } from 'react';
import styles from './Textarea.module.css';

interface TextareaProps {
  disabled?: boolean;
  errorMessage?: string;
  hasError?: boolean;
  hint?: string;
  label?: string;
  name: string;
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  placeholder?: string;
  required?: boolean;
  rows?: number;
  value?: string | ReadonlyArray<string> | number | undefined;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ disabled, errorMessage, hasError, hint, label, name, onChange, placeholder, required, rows, value }: TextareaProps, ref) => {
  const id = `textarea-${name}`;
  const error = Boolean(errorMessage) || hasError;

  return (
    <div className={styles.container}>
      {label && (
        <label className={clsx(styles.label, error && styles.error)} htmlFor={id}>
          {label} {required && <span>*</span>}
        </label>
      )}
      <textarea className={clsx(styles.textarea, error && styles.error)} disabled={disabled} id={id} name={name} onChange={onChange} placeholder={placeholder} ref={ref} rows={rows} value={value} />
      {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
      {hint && !errorMessage && !hasError && <div className={styles.hint}>{hint}</div>}
    </div>
  );
});

Textarea.displayName = 'Textarea';

export default Textarea;
